import { stripTags } from "./chatStream";
import { LANGUAGE_NAMES } from "@/lib/indianLanguages";
import { replyLanguage } from "./replyLanguage";
export { replyLanguage } from "./replyLanguage";

export const cleanSpeechText = (text) => stripTags(text)
  .replace(/\[([^\]]+)\]\(https?:\/\/[^)]+\)/g, "$1").replace(/https?:\/\/\S+/g, "")
  .replace(/^\s*(?:#{1,6}|[-*+])\s+/gm, "").replace(/[*_`~]/g, "").replace(/\s+/g, " ").trim();

export const speechChunks = (text) => {
  const parts = [];
  let remaining = text;
  while (remaining.length > 220) {
    const section = remaining.slice(0, 220);
    const boundary = Math.max(section.lastIndexOf(". "), section.lastIndexOf("? "), section.lastIndexOf("! "), section.lastIndexOf("। "));
    const space = section.lastIndexOf(" ");
    const end = boundary > 80 ? boundary + 1 : space > 80 ? space : 220;
    parts.push(remaining.slice(0, end)); remaining = remaining.slice(end).trimStart();
  }
  if (remaining) parts.push(remaining);
  return parts;
};

export const cancelDeviceSpeech = (runtime) => {
  runtime.generation++;
  if (runtime.utterance) {
    runtime.utterance.onstart = runtime.utterance.onend = runtime.utterance.onerror = runtime.utterance.onboundary = null;
    runtime.utterance = null;
  }
  // The browser queue can remain paused even after an utterance reference clears.
  const synth = runtime.synth;
  runtime.synth = null;
  synth?.cancel(); synth?.resume();
};

export const speakReply = (runtime, message, settings, setState) => {
  cancelDeviceSpeech(runtime);
  const generation = runtime.generation;
  const update = (fields) => { if (generation === runtime.generation) setState((old) => ({ ...old, ...fields })); };
  setState({ messageId: message.id, status: "loading", error: "", part: 0, parts: 1, progress: 0 });
  const synth = window.speechSynthesis;
  if (!synth || typeof window.SpeechSynthesisUtterance === "undefined") {
    update({ status: "error", error: "Read aloud is not available in this browser. Your text reply is still available." }); return;
  }
  const text = cleanSpeechText(message.text), language = replyLanguage(text);
  const voices = synth.getVoices().filter((voice) => voice.localService === true);
  const matching = voices.filter((voice) => voice.lang.toLowerCase().split(/[-_]/)[0] === language);
  const voice = settings.voice === "auto" ? matching.find((item) => item.lang.toLowerCase() === `${language}-in`) || matching.find((item) => item.default) || matching[0] : matching.find((item) => item.voiceURI === settings.voice);
  if (!voice) {
    update({ status: "error", error: matching.length ? `Choose Automatic or a ${LANGUAGE_NAMES[language]} voice to read this reply.` : `No on-device ${LANGUAGE_NAMES[language]} voice is available in this browser. Your text reply is still available.` }); return;
  }
  const parts = speechChunks(text);
  if (!parts.length) { update({ status: "error", error: "This reply has no text to read aloud." }); return; }
  runtime.synth = synth;
  update({ parts: parts.length });
  const sayPart = (part) => {
    if (generation !== runtime.generation) return;
    const utterance = new window.SpeechSynthesisUtterance(parts[part]); runtime.utterance = utterance;
    utterance.voice = voice; utterance.lang = voice.lang; utterance.rate = settings.speed;
    utterance.onstart = () => update({ status: "playing", part });
    utterance.onboundary = (event) => update({ progress: Math.round(100 * (part + event.charIndex / parts[part].length) / parts.length) });
    utterance.onerror = () => update({ status: "error", error: "The device could not read this reply. Please try another on-device voice." });
    utterance.onend = () => {
      if (generation !== runtime.generation) return;
      runtime.utterance = null;
      if (part + 1 < parts.length) sayPart(part + 1);
      else update({ status: "ended", progress: 100 });
    };
    try { synth.speak(utterance); }
    catch { update({ status: "error", error: "Read aloud could not start in this browser." }); }
  };
  sayPart(0);
};